import Modal from "react-bootstrap/Modal";
import React, { useContext } from "react";
import { ModalContext } from "../../contexts/ModalContext";
import { ToastMessageContext } from "../../contexts/ToastMessageContext";
import SubmitButtonWithSpinner from "./SubmitButtonWithSpinner";
import { Button, NavLink } from "react-bootstrap";

export default function BaseFormModal({
  modalTitle,
  children,
  formID = "modal-form",
  submitBtnText = "Ajouter",
  submitFct,
  getFormDataFct = () => new Object(),
  validateForm = (data) => [],
  extraLeftFooterButtons = undefined,
  onCancel = undefined,
  submitButtonClassName = undefined,
}) {
  const { hideCurrentModal } = React.useContext(ModalContext);
  const { toastMessage } = useContext(ToastMessageContext);
  const handleCancel = onCancel || hideCurrentModal;

  async function handleSubmit() {
    let formData = getFormDataFct();

    let errorList = validateForm(formData);
    if (errorList.length > 0) {
      errorList.forEach((error) => {
        toastMessage(error, "danger");
      });
      return false;
    }
    let success = await submitFct(formData);
    if (success) {
      hideCurrentModal();
    }
    return success;
  }

  return (
    <>
      <Modal.Header closeButton={true} onHide={() => hideCurrentModal()}>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id={formID} onSubmit={handleSubmit}>
          {children}
        </form>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between align-items-center">
        {extraLeftFooterButtons && (
          <div className="me-auto">{extraLeftFooterButtons}</div>
        )}
        <div className="ms-auto d-flex gap-2">
          <Button variant={"secondary"} onClick={() => handleCancel()}>
            Annuler
          </Button>
          <SubmitButtonWithSpinner
            submitFct={handleSubmit}
            formID={formID}
            className={submitButtonClassName}
          >
            {submitBtnText}
          </SubmitButtonWithSpinner>
        </div>
      </Modal.Footer>
    </>
  );
}
